<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/CustomerSegments/Form'

export default {
    name: 'CustomerSegmentsCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.customer-segments.store'))
        }
    }
}
</script>
